import { fullName, profile } from "./profile";

export const accessibility = {
	experience: "Interactive business card",
	expand: "Expand the QR into a 3D business card",
	collapse: "Show the scannable QR",
	hint: "Click or press Enter to expand the QR. Move your cursor to explore the 3D view, then click again to return.",
	qr: `QR to ${fullName}'s website`,
};

export const labels = {
	loading: "Preparing pixels…",
	email: "Email me",
	copyEmail: "Copy email address",
	linkedin: "LinkedIn",
	github: "GitHub",
	emailTooltip: `Email ${profile.email}`,
	toggleTooltip: "Click to expand or collapse the QR",
};

export const messages = {
	emailCopied: "Email copied!",
	emailCopyFailed: "Could not copy email. Please try again.",
	noWebGL:
		"The 3D view is unavailable in this browser. You can still scan the QR.",
	missingFile:
		"A file could not be loaded. Keep index.html, app.js and the vendor folder together in the dist folder.",
	startupError: "The page could not start. Details: ",
	loadingError: "loading error",
	noCanvas: "Canvas 2D is unavailable",
};

export const interactionConfig = {
	reducedMotionQuery: "(prefers-reduced-motion: reduce)",
	toggleKeys: ["Enter", " "],
};
